import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../ui/button';
import { FileText } from 'lucide-react';

export default function StickyRFQ() {
  const location = useLocation();
  if (location.pathname === '/request-quote') return null;

  return (
    <div className="sticky-rfq-fab md:hidden" data-testid="sticky-rfq-mobile">
      <Link to="/request-quote">
        <Button className="rounded-full shadow-lg text-white px-5 py-3 flex items-center gap-2" style={{ background: 'var(--brand-teal)' }}>
          <FileText className="w-4 h-4" />
          Get Quote
        </Button>
      </Link>
    </div>
  );
}
